<script setup>

import {defineProps, defineEmits} from "vue";

defineProps({
    title: String,
    titleOutlined: Boolean,
    color: String,
    showAddAction: Boolean,
    showDeleteAction: Boolean,
    readonly: Boolean,
});

const emit = defineEmits(['add', 'delete']);

function add() {
    emit('add');
}

function remove() {
    emit('delete');
}

</script>

<template>
    <div>
        <fieldset>
            <legend>
                <v-chip
                    v-if="title"
                    :color="color ? color : 'teal'"
                    small
                    :outlined="titleOutlined"
                    class="white--text ml-2 mr-2"
                >
                    <strong>{{ title}}</strong>
                </v-chip>
                <v-btn
                    icon
                    color="teal"
                    v-if="showAddAction"
                    :disabled="readonly"
                    @click="add"
                >
                    <v-icon>mdi-plus-circle-outline</v-icon>
                </v-btn>
                <v-btn
                    icon
                    color="red"
                    v-if="showDeleteAction"
                    :disabled="readonly"
                    @click="remove"
                >
                    <v-icon>mdi-trash-can</v-icon>
                </v-btn>
            </legend>
            <v-container fluid>
                <slot></slot>
            </v-container>
        </fieldset>
    </div>
</template>